import LandingPage from "../LandingPage";

const Bootstrap = () => {
  return <LandingPage />;
};

export default Bootstrap;
